import { Auth } from "aws-amplify";

export default async ({ email, password }) => Auth.signIn(email, password);
